import React from "react";

import { Input as CobaltInput } from "Cobalt/Input";
import CommonInput from "Common/forms/SIFormInput";

import { useThemeContext } from "./Context";

export type InputProps = {
  className?: string;
  prependContent?: string;
  appendContent?: string;
  theme: "default" | "condensed";
  meta?: { touched: boolean; error?: any; warning?: any };
  input?: { value: string | number };
  mask: unknown;
  guide: boolean;
  showMask: boolean;
};

export const Input = (props: InputProps) => {
  const { cobalt } = useThemeContext();

  const InputComponent = cobalt ? CobaltInput : CommonInput;
  return <InputComponent {...props} />;
};
